import { LastMessageSystem } from '@halo/ui-chat-react';
import type { MsgGroupUnrestrictedContentProps } from './msg-group-unrestricted-content';
import { MsgGroupUnrestrictedContent } from './msg-group-unrestricted-content';

export interface MsgGroupUnrestrictedPreviewProps extends MsgGroupUnrestrictedContentProps {}

export const MsgGroupUnrestrictedPreview = memo(function MsgGroupUnrestrictedPreview({
  message,
}: MsgGroupUnrestrictedPreviewProps) {
  return (
    <LastMessageSystem>
      <MsgGroupUnrestrictedContent message={message} />
    </LastMessageSystem>
  );
});
